module.exports = __webpack_public_path__ + "static/media/responsable.cb7f60a5.svg";